import React from 'react';
import * as styles from './WrappingTwoColumnLayout.module.scss';

interface WrappingTwoColumnLayoutProps {
  left?: React.ReactNode;
  right?: React.ReactNode;
}

const WrappingTwoColumnLayout = ({
  left,
  right,
}: WrappingTwoColumnLayoutProps) => {
  if (left && right) {
    return (
      <div className={styles.container}>
        <div className={styles.left}>{left}</div>
        <div className={styles.right}>{right}</div>
      </div>
    );
  }
  if (left) {
    return <>{left}</>;
  }
  if (right) {
    return <div className={styles.right}>{right}</div>;
  }
  return null;
};

export default WrappingTwoColumnLayout;
